<template>
	<page>
		<module>
			<view-list ref="view" :work-type="workType" dynamic-field :field-sort="false" :view-config="auth('b_defect_summary_viewmanage')">
				<template #search>
					<m-search ref="search" :default-data="defaultSearchData">
                        <m-search-item label="产品">
                            <c-select name="product_ids" async multiple @search="searchProduct" ></c-select>
                        </m-search-item>

                        <m-search-item label="质检人员">
                            <c-select name="test_user_ids" async multiple @search="searchSysUser" ></c-select>
                        </m-search-item>

                        <!-- <m-search-item label="质检单创建时间">
                            <c-datetime type="date" :range="freeEdition ? {limit: 30} : true" start-name="start_date" end-name="end_date" :clear="false"></c-datetime>
                        </m-search-item> -->

						<m-search-item label="质检时间">
							<c-datetime type="date" :range="freeEdition ? {limit: 30} : true" start-name="test_start_date" end-name="test_end_date" :clear="false"></c-datetime>
						</m-search-item>
						<m-search-item label="统计维度">
							<c-select name="dimension_id" :options="dimensionOption.active" :disable-options="dimensionOption.disabled" :clear="false">
								<template #option="{data, selected, disabled}">
									<select-option
										:name="data.name"
										:selected="selected"
										:vip="disabled"
									></select-option>
								</template>
							</c-select>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button v-if="auth('b_defect_summary_export')" v-lock="lock('b_defect_summary_export')" prepend-icon="tf-export" @click="$refs.view.exportReportByViewId()">导出</c-button>
				</template>
			</view-list>
		</module>
	</page>
</template>

<script>
	import {mapState, mapGetters} from 'vuex'

	export default {
		data() {
			let now = new Date();
			return {
                workType:81,                    //【生产】质检数据报表
                defaultSearchData: {
					dimension_id: 141,          //默认维度【产品】
					date_field: 'create_date',
					start_date: new Date(now.getFullYear(), now.getMonth(), now.getDate()-30).format('yyyy-MM-dd'),
					end_date: new Date().format('yyyy-MM-dd')
				}
			}
		},

		computed: {
			...mapState(['auditStateDic', 'dateFieldOptions']),
			...mapGetters(['freeEdition']),

			dimensionOption() {
				let options = [
                    {name: '产品',value: 141},
                    {name: '工单',value: 142}
                ];

				return {
					active: options,
					disabled: this.freeEdition ? options.filter(item => item.name.includes('+')).map(item => item.value) : []
				}
			}
		},

		methods: {
            /*******搜索【产品】下拉框信息*****************/
            searchProduct(keyword, resolve){
                this.request({
                    url:'/system/options',
                    data: {
                        options_code:'SELF_PRODUCT',
                        keyword:keyword
                    },
                    success:data => {
                        resolve(data);
                    }
                })
            },
			/*******搜索【员工】下拉框信息*****************/
			searchSysUser(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'SYSUSER',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>